import PropTypes from "prop-types";
import "react-calendar-heatmap/dist/styles.css";
import ReactCalendarHeatmap from "react-calendar-heatmap";

import { HeatmapChartContainer } from "./HeatmapChart.styles";
import { NoDataMessage } from "features/Strategy/v2/Detail/StrategyDetails.styles";

export const HeatmapChart = ({ startDate, endDate, values }) => {
  const getCellClass = (count) => {
    if (count === 0) {
      return "gray-cell";
    } else if (count > 0) {
      return "green-cell";
    } else if (count < 0) {
      return "red-cell";
    } else {
      return "white-cell";
    }
  };
  return (
    <HeatmapChartContainer>
      <div className="chart-wrapper">
        {startDate && endDate && values && (
          <ReactCalendarHeatmap
            startDate={startDate}
            endDate={endDate}
            values={values}
            showWeekdayLabels={true}
            titleForValue={(value) => (value ? `${value.count}` : 0)}
            classForValue={(value) =>
              value
                ? `data-cell ${getCellClass(value.count)}`
                : `data-cell white-cell`
            }
          />
        )}
        {!(startDate && endDate && values) && (
          <NoDataMessage>No data to display</NoDataMessage>
        )}
      </div>
    </HeatmapChartContainer>
  );
};

HeatmapChart.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  values: PropTypes.array,
};
